import { getApp, getApps, initializeApp } from 'firebase/app';
import {
  signInWithEmailAndPassword,
  initializeAuth,
  browserLocalPersistence,
  getIdToken as firebaseGetIdToken,
  User,
} from 'firebase/auth';
import {
  initializeAppCheck,
  CustomProvider,
  getToken as firebaseGetAppCheckToken,
  AppCheck,
} from 'firebase/app-check';
import { defaultConfig } from '@medely/base';
import { CloudflareProviderOptions } from './turnstile';

// https://github.com/firebase/firebase-js-sdk/issues/7888#issuecomment-2114939292

const app =
  getApps().length === 0
    ? initializeApp({ ...defaultConfig.firebaseConfig, appId: 'medely-app' }, 'medely-app')
    : getApp();

const siteKey = '0x4AAAAAABNtPu2r7QAA3XLP';

const HTTP_ENDPOINT =
  process.env.REACT_APP_RELEASE_STAGE === 'production'
    ? 'https://run.medely.com/app-check-provider'
    : 'https://staging-run.medely.com/app-check-provider';

let appCheckInstance: AppCheck | undefined;

if (process.env.REACT_APP_RELEASE_STAGE === 'production') {
  const cpo = new CloudflareProviderOptions(HTTP_ENDPOINT, siteKey);
  const provider = new CustomProvider(cpo);
  appCheckInstance = initializeAppCheck(app, { provider });
}

// NOTE: getAuth() seems to cause a 20 second hang intermittently on embedded mobile
const auth = initializeAuth(app, { persistence: browserLocalPersistence });

export default auth;
export { auth as firebaseAuth, signInWithEmailAndPassword };

// Mirrors mobile's firebase.mobile.ts surface (see the comment on
// multi-platform/tsconfig.json's moduleSuffixes) - not otherwise used on web,
// since firebase/auth's User already exposes getIdToken() directly.
export const getIdToken = (user: User, forceRefresh?: boolean) =>
  firebaseGetIdToken(user, forceRefresh);

export const getAppCheckToken = (forceRefresh?: boolean) => {
  if (!appCheckInstance) {
    throw new Error('App Check has not been initialized yet');
  }
  return firebaseGetAppCheckToken(appCheckInstance, forceRefresh);
};
